/**
 * "Ordem dos agentes" (the owner's ask, 15/10): when one AI stops because its plan's limit ran out,
 * the next one in the person's order takes the same request — and the local free AI can be the
 * last step. Only a limit hands work over: a wrong answer or a crash never does.
 */

import type { LocalAgentId } from './localAgent'

/**
 * The agents' own words for "you ran out": Claude Code's usage-limit line and 5-hour window, Codex's
 * "hit your usage limit", the APIs' 429 rate_limit_error and insufficient_quota. Specific phrases,
 * so a reply that merely talks about rate limiters in someone's code is not mistaken for one.
 */
const LIMIT = [
  /usage limit reached/i,
  /hit your (usage )?limit/i,
  /\brate_limit_error\b/i,
  /\binsufficient_quota\b/i,
  /exceeded your current quota/i,
  /\b\d+-hour limit reached\b/i,
]

export function limitHit(output: string): boolean {
  return LIMIT.some((pattern) => pattern.test(output))
}

/** The first agent of the order not tried yet, or null when the order is spent. */
export function nextAgent(order: LocalAgentId[], tried: Set<LocalAgentId>): LocalAgentId | null {
  return order.find((agent) => !tried.has(agent)) ?? null
}
